<div class="a4-page">
  <!-- Default Header -->
  <ng-container *ngIf="!useLegacyView && brandType !== 'healthpluspeople'">
    <header class="a4-header">
      <img
        *ngIf="logoSrc"
        class="brand-logo"
        [src]="logoSrc"
        [alt]="brandAltText"
      />
    </header>
  </ng-container>

  <!-- Custom Header for Health+People - Only logo -->
  <ng-container *ngIf="!useLegacyView && brandType === 'healthpluspeople'">
    <header class="a4-header healthplus-header">
      <img src="assets/img/health_People.png" class="healthplus-logo" alt="Health+People" />
    </header>
  </ng-container>

  <!-- Legacy Header for Agrilabour -->
  <ng-container *ngIf="useLegacyView && brandType === 'agrilabour'">
    <div class="agrilabour-header">
      <div class="row">
        <div class="col-6">
          <img src="assets/img/agrilabour-logo-01.png" class="agrilabour-logo" alt="Agri Labour Australia" />
        </div>
        <div class="col-6 text-right agrilabour-contact-info">
          <div>1300 247 823</div>
          <div>G01N 527 Gregory Terrace,</div>
          <div>Fortitude Valley QLD 4006</div>
          <div>ABN 23 142 526 216</div>
          <div>ACN 142 526 216</div>
          <div><a href="http://www.agrilabour.com.au" class="agrilabour-url">www.agrilabour.com.au</a></div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Body -->
  <main class="a4-content">
    <ng-content></ng-content>
  </main>

  <!-- Default Footer -->
  <ng-container *ngIf="!useLegacyView && brandType !== 'healthpluspeople'">
    <footer class="a4-footer">
      <div class="footer-text">
        <div *ngFor="let line of footerLines" class="footer-line">{{ line }}</div>
      </div>
      <div class="footer-icons" *ngIf="footerIcons?.length">
        <img
          *ngFor="let icon of footerIcons"
          [src]="icon"
          class="footer-icon"
          alt=""
          aria-hidden="true"
        />
      </div>
    </footer>
  </ng-container>
  
  <!-- Custom Footer for Health+People -->
  <ng-container *ngIf="!useLegacyView && brandType === 'healthpluspeople'">
    <footer class="a4-footer healthplus-footer">
      <div class="healthplus-contact-info">
        <div>A G0 1N 527 Gregory Terrace, Fortitude Valley QLD 4006</div>
        <div>T +617 4638 0071 | E info@healthpluspeople.com.au</div>
        <div class="healthplus-url">HEALTHPLUSPEOPLE.COM.AU</div>
      </div>
      <div class="footer-icons">
        <!-- These icons should be created and added to assets/img folder -->
        <img src="assets/assets/branding/healthpluspeople/rcsa.png" class="footer-icon" alt="RCSA"/>
        <img src="assets/assets/branding/healthpluspeople/staffsure.png" class="footer-icon" alt="StaffSure"/>
        <img src="assets/assets/branding/healthpluspeople/iso.jpg" class="footer-icon" alt="Hire"/>
      </div>
    </footer>
  </ng-container>
  
  <!-- Legacy Footer is handled inside the content for Agrilabour -->
</div>